'use client';

import React from 'react';
import { Drawer, Text, IconButton, Flex } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import FilterSidebarSkeleton from '@/components/ui/FilterSidebarSkeleton';
import FilterSidebar from './FilterSidebar';
import { type FilterOptions, type FilterSummary } from '../types/filters';
import type { ProductSortBy } from '@skin-seoul/service';
import type { TaxonomyCategory } from '../utils/categoryUtils';
interface MobileFilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onFilterChange?: (filters: FilterOptions) => void;
  onSortByChange?: (sortBy: string) => void;
  category?: string;
  subcategory?: string;
  subSubcategory?: string;
  brand?: string;
  filterSummary?: FilterSummary;
  sortBy?: ProductSortBy;
  productCount?: number;
  hideCategoryFilter?: boolean;
  hideAllFilters?: boolean;
  categories?: TaxonomyCategory[];
}
const MobileFilterDrawer = ({
  isOpen,
  onClose,
  onFilterChange,
  onSortByChange,
  category,
  subcategory,
  subSubcategory,
  brand,
  filterSummary,
  sortBy,
  productCount,
  hideCategoryFilter = false,
  hideAllFilters = false,
  categories
}: MobileFilterDrawerProps) => {
  return <Drawer.Root placement="bottom" initialFocusEl={() => null} open={isOpen} onOpenChange={details => {
    if (!details.open) {
      onClose();
    }
  }} data-sentry-element="Drawer.Root" data-sentry-component="MobileFilterDrawer" data-sentry-source-file="MobileFilterDrawer.tsx">
      <Drawer.Backdrop data-sentry-element="Drawer.Backdrop" data-sentry-source-file="MobileFilterDrawer.tsx" />
      <Drawer.Positioner data-sentry-element="Drawer.Positioner" data-sentry-source-file="MobileFilterDrawer.tsx">
        <Drawer.Content alignItems="stretch" backgroundColor="white" width="100%" height="95%" borderRadius="12px 12px 0 0" padding="0" gap={0} data-sentry-element="Drawer.Content" data-sentry-source-file="MobileFilterDrawer.tsx">
          <Drawer.Header alignItems="center" display="flex" flexDirection="row" width="100%" padding="16px 20px" justifyContent="space-between" flexShrink={0} data-sentry-element="Drawer.Header" data-sentry-source-file="MobileFilterDrawer.tsx">
            <Flex align="center" gap={2} data-sentry-element="Flex" data-sentry-source-file="MobileFilterDrawer.tsx">
              <LucideIcon name="ListFilter" boxSize={4} data-sentry-element="LucideIcon" data-sentry-source-file="MobileFilterDrawer.tsx" />
              <Text fontWeight="medium" textStyle="heading.h6" color="neutral.800" data-sentry-element="Text" data-sentry-source-file="MobileFilterDrawer.tsx">
                Filters
              </Text>
            </Flex>
            <IconButton _hover={{
            backgroundColor: 'transparent'
          }} aria-label="Close filters" backgroundColor="transparent" border="none" cursor="pointer" width={6} height={6} onClick={onClose} justifyContent="end" data-sentry-element="IconButton" data-sentry-source-file="MobileFilterDrawer.tsx">
              <LucideIcon name="X" color="neutral.800" boxSize={4} data-sentry-element="LucideIcon" data-sentry-source-file="MobileFilterDrawer.tsx" />
            </IconButton>
          </Drawer.Header>

          <Drawer.Body padding="20px 20px 60px 20px" flex="1 1 auto" overflow="auto" width="100%" data-sentry-element="Drawer.Body" data-sentry-source-file="MobileFilterDrawer.tsx">
            <QueryBoundary loadingFallback={<FilterSidebarSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="MobileFilterDrawer.tsx">
              <FilterSidebar onFilterChange={onFilterChange} onSortByChange={onSortByChange} category={category} subcategory={subcategory} subSubcategory={subSubcategory} brand={brand} filterSummary={filterSummary} sortBy={sortBy} productCount={productCount} hideCategoryFilter={hideCategoryFilter} hideAllFilters={hideAllFilters} categories={categories} data-sentry-element="FilterSidebar" data-sentry-source-file="MobileFilterDrawer.tsx" />
            </QueryBoundary>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>;
};
export default MobileFilterDrawer;